import { ca } from '@cian/analytics';

interface ITrackDeleteFavoriteParams {
  label: string;
  sc: object;
  products: unknown;
  page: Record<string, unknown>;
}

export function trackDeleteFavorite({ label, sc, products, page }: ITrackDeleteFavoriteParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_listing_in_map',
    label,
    sc,
    products,
    page,
  });
}
